import type { ResourceArticle } from '~/types/ResourceArticle'

export const understandingAnxietyArticle: ResourceArticle = {
  uid: 'understanding-anxiety',
  thumbnailImageUrl: 'https://cdn.hubofhope.co.uk/public/img/thumbs/RESOURCES_ANXIETY_800x800.jpg',
  thumbnailImageAlt: 'Anxiety',
  title: 'Understanding anxiety',
  supportNeedCategoryUid: 'KxwjLfly64Cy5KyNfFwB',
  supportNeedCategoryLabel: 'Anxiety',
  isFeatured: true,
  excerpt:
    "Anxiety is a normal and necessary part of life and the way we have evolved to recognise and avoid danger. It is part of a 'fight or flight' response which readies our body for action, increasing our breathing and heart rate. In turn we might feel faint, sweaty or breathless.",
  content: `
  <div class="prose mt-4">
    <p class="font-bold">
      Anxiety is a normal and necessary part of life and the way we have evolved to recognise and avoid danger. It is part of a 'fight or flight' response which readies our body for action, increasing our breathing and heart rate. In turn we might feel faint, sweaty or breathless.
    </p>
  
    <p class="mt-4">
      Sometimes anxiety can be difficult to cope with. Often this can be when we start worrying that these manifestations of anxiety mean something dangerous in themselves, for example that we are going to collapse, have a heart attack or lose control.
    </p>
  
    <figure class="my-8">
      <img src="https://cdn.hubofhope.co.uk/public/img/thumbs/pexels-tim-douglas-6567352_800x800.jpg"
           alt="Anxiety article image" 
           class="max-w-md w-full h-auto rounded shadow-md mx-auto">
    </figure>
  
    <p>
      This can lead to a 'panic attack' where these worrying thoughts lead to an increase in the bodily sensations of anxiety, leading to more worrying thoughts. We might start avoiding specific places or things that have become associated with anxiety (phobias), or find it difficult to go out at all (agoraphobia). Sometimes we can feel compelled to check things repeatedly, or to repeat certain thoughts or actions to stave off anxiety or worrying thoughts 
      (<a href="/resource/obsessions-compulsions" class="text-blue-500 underline hover:text-blue-700">see Obsessions & compulsions</a>).
    </p>
  
    <p class="mt-4">
      Experiences of anxiety may also be linked to past traumatic experiences 
      (<a href="/resource/trauma-post-traumatic-stress" class="text-blue-500 underline hover:text-blue-700">see Trauma & post-traumatic stress</a>).
    </p>
  
    <h2 class="font-semibold text-lg font-brown text-primary mt-8">Seeking support</h2>
    <p class="mb-8">
      In terms of what can help, there are many good self-help resources. Therapy or counselling can help us understand what might have led to our feelings of anxiety, and what might be keeping it going, and can help us find ways to support ourselves and to regulate our physical and emotional states.
    </p>
  </div>`
}
